require 'angular'

angular.module('workflow.app')
  .controller('SourcesController', require './SourcesController')
  .controller('CountrySourcesController', require './CountrySourcesController')
  .directive 'worldMap', ($state) ->
    return {
      link: (scope, element) ->
        element.vectorMap
          map: 'world_mill_en'
          backgroundColor: null
          borderColor: '#818181'
          borderOpacity: 0.1
          borderWidth: 0.25
          color: '#ddd'
          enableZoom: false
          zoomOnScroll:false
          hoverColor: 'white'
          hoverOpacity: 0.5
          selectedColor: '#000'
          selectedRegion: null
          showTooltip: true
          series:
            regions: [
              values: scope.mapping
              attribute: 'fill'
              scale: {
                full: '#f26522'
                partial: '#f26522'
              }
            ]
          onRegionClick: (evt, label, code) ->
            $('.jvectormap-tip').remove()
            $state.go('country-sources', {isoCode: label.toLowerCase()})
    }
